import { render, staticRenderFns } from "./Input-Workgroup.vue?vue&type=template&id=b7e1f9f0&lang=pug"
import script from "./Input-Workgroup.vue?vue&type=script&lang=ts"
export * from "./Input-Workgroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports